import { Component, ViewEncapsulation, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'organization-search',
  templateUrl: 'organization.search.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})

export class OrganizationManagementSearchComponent implements OnInit {
  public queryString: string;
  @Output() searchSubmitted: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
  }


  searchOrganizations() {
      this.searchSubmitted.emit(this.queryString);
  }
}
